import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { keyframes } from '@emotion/react';
import { TRUST_LOGOS } from './homePageContent';

const MARQUEE_COPIES = 4;
const marqueeScroll = keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(-${100 / MARQUEE_COPIES}%); }
`;

const TrustLogoMarquee = () => {
	const trackLogos = Array.from({ length: MARQUEE_COPIES }, () => TRUST_LOGOS).flat();

	return (
		<Box
			position='relative'
			overflow='hidden'
			w='100%'
			py={1}
			sx={{
				'&::before': {
					content: '""',
					position: 'absolute',
					top: 0,
					bottom: 0,
					left: 0,
					width: { base: '48px', md: '100px' },
					bgGradient: 'linear(to-r, white, transparent)',
					zIndex: 1,
					pointerEvents: 'none',
				},
				'&::after': {
					content: '""',
					position: 'absolute',
					top: 0,
					bottom: 0,
					right: 0,
					width: { base: '48px', md: '100px' },
					bgGradient: 'linear(to-l, white, transparent)',
					zIndex: 1,
					pointerEvents: 'none',
				},
			}}>
			<Flex
				w='max-content'
				gap={4}
				px={2}
				animation={`${marqueeScroll} 32s linear infinite`}
				willChange='transform'
				_hover={{ animationPlayState: 'paused' }}>
				{trackLogos.map((logo, i) => (
					<Flex
						key={`${logo}-${i}`}
						align='center'
						flexShrink={0}
						px={6}
						py={3}
						rounded='full'
						bg='gray.50'
						border='1px solid'
						borderColor='gray.100'
						whiteSpace='nowrap'>
						<Text fontSize='sm' fontWeight='bold' color='gray.500' mb={0}>
							{logo}
						</Text>
					</Flex>
				))}
			</Flex>
		</Box>
	);
};

export default TrustLogoMarquee;
